const riot = require('riot');

riot.tag2('page-user', '<div class="bg-cream h-full f flex-column"> <div class="sticky t0 z100" data-is="module-header" title="{t(&quot;user.title&quot;)}" close="{true}"> <yield to="right"> <button type="submit" form="user_form">{t(⁗header.done⁗)}</button> </yield> </div> <form class="w-full container px20 pt26" id="user_form" ref="form" onsubmit="{done}"> <div class="f flex-between"> <div class="fw6 fs16 mb20 lh10">{t(⁗user.user_name⁗)}</div> <div class="text-danger fw5" if="{refs.form.user_name.value.length &gt; 10}">{t(⁗user.error_message⁗)}</div> </div> <input class="mb32 w-full bg-white rounded-8 border border-dark-012 pl20 py13 fs16 fw6" type="text" name="user_name" riot-value="{child.name}" oninput="{_.noop}"> <div class="fw6 fs16 mb20 lh10">{t(⁗user.color_label⁗)}</div> <div class="rounded-8 border border-dark-012 overflow-hidden cursor-pointer mb110"> <div class="bg-white border-dark-012 h52 f fm flex-between px16 {&quot;border-bottom&quot;: isShow}" onclick="{toggleShow}"> <div class="f fm"> <div class="circle s20 flex-fixed mr12 bg-custom-{selectedColor}"></div> <div class="fs16 fw6">{getColorText(selectedColor)}</div> </div><i class="icon-arrow_right text-dark-026 fs20 rotate-90 {&quot;hide&quot;: isShow}"></i> </div> <div class="transition max-h0 overflow-hidden" ref="other-colors"> <div> <div class="bg-white border-bottom-not-last h52 border-dark-012 f fm px16" each="{color in otherColors}" onclick="{changeColor}"> <div class="circle s20 flex-fixed mr12 bg-custom-{color}"></div> <div class="fs16 fw6">{getColorText(color)}</div> </div> </div> </div> </div> <div class="f fr fs16 fw6 text-danger cursor-pointer" if="{child !== &quot;new&quot;}" onclick="{confirmDelete}">{t(⁗user.delete_user⁗)}</div> </form> </div>', '', '', function(opts) {
    this.preload = async({req, res}) => {
      if (req.params.id !== "new") {
        var res = await app.api.request({
          method: 'get',
          url: `/web/children/${req.params.id}`,
        });
      }

      var selectedColor = req.params.id === "new" ? "blue" : res.data.child.theme_color;
      var otherColors = this.colors.filter(color => color !== selectedColor);

      var child = req.params.id === "new" ? "new" : res.data.child;

      return {
        child,
        selectedColor,
        otherColors,
      }
    };

    this.colors = [
      "blue",
      "yellow",
      "pink",
      "purple",
      "green",
    ];

    this.toggleShow = () => {
      this.isShow = !this.isShow;
      this.update();

      if (this.isShow) {
        this.refs['other-colors'].style.maxHeight = getComputedStyle(this.refs['other-colors'].children[0]).height;
      }
      else {
        this.refs['other-colors'].style.maxHeight = 0;
      }
    };

    this.changeColor = (e) => {
      this.selectedColor = e.item.color;
      this.otherColors = this.colors.filter(color => color !== this.selectedColor);
      this.toggleShow();
      this.update();
    }

    this.getColorText = (color) => {
      return t(`user.${color}`);
    };

    this.done = async(e) => {
      e.preventDefault();

      var data = {
        name: this.refs.form.user_name.value,
        theme_color: this.selectedColor,
      };

      var method = this.child === "new" ? "post" : "put"

      var url = this.child === "new" ? 'web/children' : `/web/children/${this.child.id}`

      try {
        await app.api.request({
          method, url, data,
        });

        spat.modal.alert(t("message.saved"));
        spat.router.push('/');
      }
      catch(e) {

      }
    };

    this.confirmDelete = async() => {
      var message = t("user.confirm_delete")
      var result = await spat.modal.confirm(message);
      if (!result) return ;
      var res = await app.api.request({
        method: 'delete',
        url: `/web/children/${this.child.id}`,
      });
      spat.router.push('/');
    };
});